import ALLOWED_DOMAINS from './allowed-domains'

const travel = {
  all: [
    'welcome_again',
    'promo',
    'bringafriend',
    'bonus',
    'waiting_search',
    'waiting_check_flight',
    'list_stopper',
    'list_stopper_op',
    'list_support',
    'list_out_of_service',
    'list_out_of_service_op',
    'list_error_promo',
    'list_error_promo_op',
    'list_timeout_idk_promo',
    'list_timeout_idk_promo_op',
    'list_timeout_idk_bonus',
    'list_timeout_idk_bonus_op',
    'list_idk_bonus',
    'list_idk_bonus_op',
    'list_deactivated',
    'information',
    'list_timeout_idk_information',
    'list_timeout_idk_information_op',
    'feedback_information_welcome',
    'feedback_information_timeout_idk',
    'search',
    'list_timeout_idk_search',
    'list_timeout_idk_search_op',
    'feedback_search_options_idk',
    'feedback_search_options_timeout',
    'feedback_search_options_timeout_welcome',
    'feedback_search_options_idk_welcome',
    'feedback_search_options_response_timeout',
    'feedback_search_options_response_idk',
    'confirm',
    'list_timeout_idk_confirm',
    'list_timeout_idk_confirm_op',
    'feedback_confirm_options_idk',
    'feedback_confirm_options_idk_welcome',
    'feedback_confirm_options_timeout',
    'feedback_confirm_options_timeout_welcome',
    'no_flights',
    'no_flights_payment',
    'list_timeout_idk_no_flights',
    'list_timeout_idk_no_flights_op',
    'payment',
    'list_payment_problems',
    'list_payment_problems_op',
    'list_waiting_buy_flight',
    'list_waiting_buy_flight_op',
    'list_pending_email_confirmation',
    'list_pending_email_confirmation_op',
    'campaign',
  ],
  top: [
    'welcome_again',
    'confirm',
    'information',
    'payment',
    'list_waiting_buy_flight',
    'list_pending_email_confirmation',
    'list_support',
    'list_deactivated',
    'campaign'
  ],
  expired: [],
  isNotPool: ['list_deactivated', 'removeByUser'],
  nauta: [],
  removeByUser : ['removeByUser']
}

const op = {
  all: ['open', 'pending', 'campaign', 'resolve', 'archived', 'archiveAndUnassign', 'removed'],
  top: ['open', 'pending', 'campaign', 'resolve', 'archived', 'removed'],
  expired: ['open', 'pending', 'resolve', 'archived', 'removed'],
  isNotPool: ['nauta', 'archived', 'removed', 'removeByUser'],
  nauta: ['nauta'],
  removeByUser : ['removeByUser']
}

export default ALLOWED_DOMAINS.type === 'OP' ? op : travel
